import { useEffect, useState } from "react";
import useAuthUser from "./useAuthUser";
import { superAdminApi } from "../../services/superAdmin.service";

export default function useSuperAdminAccess() {
  const { user, isLoggedIn } = useAuthUser();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let active = true;
    if (!isLoggedIn || !user?.uid) {
      setIsSuperAdmin(false);
      setChecking(false);
      return () => { active = false; };
    }
    setChecking(true);
    superAdminApi.me()
      .then(() => { if (active) setIsSuperAdmin(true); })
      .catch(() => { if (active) setIsSuperAdmin(false); })
      .finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, [isLoggedIn, user?.uid]);

  return { isSuperAdmin, checking };
}
